<template>
    <modal
        :value="show"
        :headline="headline"
        hide-footer
        @input="$emit('input', $event)"
    >
        <form ref="form" @submit.prevent="onConfirm">
            <slot/>

            <div class="modal-footer">
                <app-button
                    size="small"
                    theme="default"
                    :disabled="isLoading"
                    @click.native="$emit('input', false)">Abbrechen</app-button>

                <app-button
                    ref="submit"
                    size="small"
                    type="submit"
                    :is-loading="isLoading"
                >{{ confirmLabel }}</app-button>
            </div>
        </form>
    </modal>
</template>

<script>
import Modal from '@/components/ui/Modal.vue'
import AppButton from '@/components/ui/Button.vue'

export default {
    name: 'FormModal',

    components: {Modal, AppButton},

    props: {
        value: {type: Boolean, required: true},
        headline: {type: String, required: true},
        confirmLabel: {type: String, default: 'OK'},
        isLoading: {type: Boolean, default: false},
    },

    data () {
        return {
            show: this.value,
        }
    },

    watch: {
        value (value) {
            this.show = value
        },
    },

    mounted () {
        this.$refs?.form?.querySelector('*[autofocus]')?.focus()
    },

    methods: {
        onConfirm () {
            if (this.isLoading) {
                return
            }

            this.$emit('confirm')
        },
    },
}
</script>
